export default __webpack_public_path__ + "static/media/pantry1-afterD-2048w.7d1ff7a2.webp";